module.exports = __webpack_public_path__ + "static/media/board.61efc67b.svg";